import { Operator } from "@jetjs/streams";
const create = (threadPool, config) => {
    let so;
    const promises = [];
    /**
     * removes the given promise from the array of promises from open thread pool submissions
     * @param p the promise to remove
     */
    const removePromise = (p) => promises.splice(promises.indexOf(p), 1);
    const handleSubmit = (promise) => {
        promises.push(promise);
        promise
            .then(v => {
            removePromise(promise);
            so.next(v);
        })
            .catch(err => {
            removePromise(promise);
            so.error(err);
        });
    };
    const next = (value) => {
        handleSubmit(threadPool.submit({
            name: config.name,
            parameter: value
        }));
    };
    return new Operator((s) => {
        so = s;
    }, next, 
    // errors are forwarded and not submitted to the thread pool task
    (err) => so.error(err), 
    // complete after all open submissions are handled
    () => Promise.all(promises).then(() => so.complete(), () => so.complete()));
};
/**
 * creates a operator that wraps a Task. Each received value will be submitted as Task to the ThreadPool.
 * Received values from task execution will be forwarded to the next piped operator or subscriber.
 *
 * @param threadPool the thread pool used to submit tasks
 * @param config the task configuration to create an operator for
 */
export const task = (threadPool, config) => {
    threadPool.addTaskConfiguration(config);
    return create(threadPool, config);
};
//# sourceMappingURL=task.js.map